import React, { useState } from 'react';
import { auth } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import "./AdminPanel.css";

export default function AdminPanel({ setIsAuthenticated }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Firebase Auth හරහා ලොග් වීම
      await signInWithEmailAndPassword(auth, email, password);
      
      // සාර්ථක නම් LocalStorage එකේ ටෝකන් සේව් කර ඇප් එක අප්ඩේට් කරයි
      localStorage.setItem("adminToken", "true");
      localStorage.setItem("adminLoginTime", Date.now());
      setIsAuthenticated(true);
    } catch (err) {
      console.error(err);
      setError("Incorrect email or password!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-panel">
      <div className="admin-card" style={{ maxWidth: '400px', margin: '100px auto', padding: '30px', textAlign: 'center' }}>
        <h2>Admin Login</h2>
        {error && <p style={{ color: 'red', fontSize: '14px', marginBottom: '10px' }}>{error}</p>}
        
        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' }}>
          <div className="form-group" style={{ textAlign: 'left' }}>
            <label>Email:</label>
            <input 
              type="email" 
              placeholder="Enter admin email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ width: '100%', padding: '10px', marginTop: '5px' }}
            />
          </div>

          <div className="form-group" style={{ textAlign: 'left' }}>
            <label>Password:</label>
            <input 
              type="password" 
              placeholder="Enter password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ width: '100%', padding: '10px', marginTop: '5px' }}
            />
          </div>

          <button type="submit" disabled={loading} className="submit-btn" style={{ padding: '10px', marginTop: '10px', cursor: 'pointer' }}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}